import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Site } from '@model';

@Injectable()
export class TreeService {
  private readonly selectSiteInListEmitter = new Subject<Site>();
  selectSiteInList$ = this.selectSiteInListEmitter.asObservable();

  selectSiteInList(site: Site): void {
    this.selectSiteInListEmitter.next(site);
  }
}
